"use client";

import { useEffect } from "react";
import { useSiteConfig } from "@/lib/useSiteConfig";

const FALLBACK_FAVICON = "/images/logo.svg";

export default function DynamicFavicon() {
  const config = useSiteConfig();
  const faviconUrl = config.brand.faviconUrl || FALLBACK_FAVICON;

  useEffect(() => {
    // Nuke any other link[rel="icon"] before adding ours — otherwise SSR or
    // React-managed icon links survive alongside and the browser picks one
    // unpredictably (it usually wins for SVG over PNG).
    document
      .querySelectorAll<HTMLLinkElement>("link[rel='icon']")
      .forEach((l) => l.remove());

    const link = document.createElement("link");
    link.rel = "icon";
    link.href = faviconUrl;
    document.head.appendChild(link);
  }, [faviconUrl]);

  return null;
}
